export const CALENDAR_SET_ACCOUNT = 'CALENDAR_SET_ACCOUNT';

export const CALENDAR_SET_ERROR = 'CALENDAR_SET_ERROR';

export const CALENDAR_SET_EVENTS = 'CALENDAR_SET_EVENTS';
